/** `/map-builder` — the shared hex-tile-kit map builder (see HexBuilder.tsx). */
export const mapBuilderEn = {
  'mapBuilder.seo.title': 'Map Builder',
  'mapBuilder.seo.description': 'Build a hex-tile map from a 3D asset kit — place, rotate, and arrange terrain tiles on a hex grid.',
  'mapBuilder.heading': 'Hex Map Builder',
  'mapBuilder.intro': 'Drop tiles from the palette onto the grid, then rotate them in 60° steps to line up their exits. Your layout is saved to this browser only.',

  'mapBuilder.notAvailableTitle': 'No Kit Configured',
  'mapBuilder.notAvailableMessage': 'This world has no 3D tile kit configured yet — nothing to build with here.',
  'mapBuilder.webglUnavailable': 'The map builder needs WebGL, which is unavailable in this browser.',

  'mapBuilder.loading': 'Loading the tile kit…',
  'mapBuilder.emptyTitle': 'Kit Is Empty',
  'mapBuilder.emptyMessage': 'This kit has no tiles yet.',

  'mapBuilder.paletteHeading': 'Tile Palette',
  'mapBuilder.paletteArmedHint': 'Click a grid cell to place this tile.',
  'mapBuilder.paletteIdleHint': 'Select a tile, then click an empty grid cell to place it.',

  'mapBuilder.selectedHeading': 'Selected Tile',
  'mapBuilder.rotationDegrees': '{degrees}°',
  'mapBuilder.rotateCcw': 'Rotate counter-clockwise',
  'mapBuilder.rotateCw': 'Rotate clockwise',
  'mapBuilder.remove': 'Remove',
  'mapBuilder.keyboardHint': 'Shortcuts: R / Shift+R to rotate, Delete to remove, Esc to deselect.',
  'mapBuilder.clearMap': 'Clear Map',
  'mapBuilder.localStorageNotice': 'Saved locally to this browser only — there is no server-side map storage yet.',
} as const
